import React from "react";
import {DowntimeAct, DowntimeActStatus} from "../../../../../model/downtime-act/DowntimeAct";
import {BlockForDisplayingText} from "../../BlockForDisplayingText";
import {useUpdateDowntimeActStatusMutation} from "../../../../../store/backend-api/backend.api";

interface Props {
    downtimeAct: DowntimeAct;
}

export const DowntimeActDescription = ({ downtimeAct }: Props) => {
    const [doUpdateDowntimeActStatus] = useUpdateDowntimeActStatusMutation();

    const onChangeCheckboxValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        doUpdateDowntimeActStatus({ number: downtimeAct.documentNumber, body: { status: event.target.checked ? DowntimeActStatus.CAUSE_ELIMINATED : DowntimeActStatus.NOTIFICATION }});
    };

    return (
        <div className='flex flex-col w-full'>
            <div className='flex justify-between w-[423px]'>
                {downtimeAct.documentNumber}
                <div className='text-black/[.60]' title='Дата создания'>{downtimeAct.notificationTime}</div>
            </div>
            <div className='flex justify-between gap-x-5 items-center'>
                <BlockForDisplayingText text={downtimeAct.description} />
                <input type='checkbox' checked={downtimeAct.status === DowntimeActStatus.CAUSE_ELIMINATED} title='Причина устранена' onChange={onChangeCheckboxValue} className='h-5 w-5' />
            </div>
        </div>
    );
};